import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import '@/api/axios'
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import '@/util/filters'
import 'vuetify/dist/vuetify.min.css'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify, {
  theme: {
    primary: '#3c8dbc',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  lang: {
    locales: { es },
    current: 'es'
  }
})
Vue.use(Vuelidate)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js